var BASWebServices;
(function (BASWebServices) {
    var HighLoadService = (function () {
        function HighLoadService($http) {
            this.$http = $http;
            this.highLoadMessage = "";
            this.fillHighLoadServiceMessage(BASWebServices.ConfigService.GET_BAS_GET_LOAD_INDICATOR());
        }
        HighLoadService.Factory = function ($http) {
            return new HighLoadService($http);
        };
        HighLoadService.prototype.fillHighLoadServiceMessage = function (path) {
            this.highLoadMessage = "";
            this.$http.get(path, {
                _this: this,
                path: path
            })
                .then(function (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var config = response.config;
                var loadIndicator = data;
                if (loadIndicator >= 2) {
                    config._this.highLoadMessage = "Dear BAS web services users,";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "due to many requests on our servers the processing of files might take longer than usual (up to several hours). We are confident that this condition will not persist.";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "We apologize for any inconviences.";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "<br/>";
                    config._this.highLoadMessage += "Your BAS team";
                }
            })
                .catch(function (response) {
                var config = response.config;
                config._this.$scope.highLoadMessage = "";
                console.error("Could not retrieve high load status from url " + path);
            });
        };
        HighLoadService.prototype.getHighLoadMessage = function () {
            return this.highLoadMessage;
        };
        return HighLoadService;
    }());
    BASWebServices.HighLoadService = HighLoadService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=HighLoadService.js.map